import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { filter, startWith, switchMap, takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-eligibility-rule-form-has-booking-option',
    templateUrl: './editor-eligibility-rule-form-has-booking-option.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityRuleFormHasBookingOptionComponent implements OnInit, OnDestroy {
  @Input() formGroup: FormGroup;

  private destroyed$ = new Subject<void>();

  bookingItemNames: { id: string, name: string }[];
  bookingOptionNames: { id: string, name: string }[];
  bookingStateNames: { id: string, name: string }[];
  bookingMetadataNames: { id: string, name: string }[];

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.bookingItemNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(bookingItemNames => this.bookingItemNames = bookingItemNames);

    this.formGroup.controls['bookingItem'].valueChanges.pipe(
      startWith(this.formGroup.controls['bookingItem'].value),
      filter(bookingItem => bookingItem !== null),
      switchMap(bookingItem => this.editorData.bookingOptionNamesForBookingItem$(bookingItem)),
      takeUntil(this.destroyed$)
    ).subscribe(bookingOptionNames =>
      this.bookingOptionNames = bookingOptionNames
    );

    this.editorData.bookingStateNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(bookingStateNames => this.bookingStateNames = bookingStateNames);

    this.editorData.bookingMetadataNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(bookingMetadataNames => this.bookingMetadataNames = bookingMetadataNames);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
